export default "__VITE_ASSET__B1h0smMD__"